import React, { useState } from "react";
import {
    Grid,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
} from "@material-ui/core";

import { makeStyles, withStyles } from '@material-ui/core/styles';

import C1InputField from "app/c1component/C1InputField";
import C1DateField from "app/c1component/C1DateField";
import C1HeaderTitle from "app/c1component/C1HeaderTitle";
import C1PopUp from "app/c1component/C1PopUp";
import VisibilityIcon from '@material-ui/icons/Visibility';

import { useStyles } from "app/c1utils/styles";
import useAuth from "app/hooks/useAuth";
import moment from "moment";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#3C77D0',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useTableStyle = makeStyles({
    table: {
        minWidth: 450,
        tableLayout: "auto",
    },
    column: {
        width: 50,
    },
});

const RaeoAppRegulatoryAgency = ({
    inputData,
    handleInputChange,
    handleDateChange,
    handleInputChangeDeep,
    errors,
    isDisabled,
    showAgencyReportList,
    isSubmitting }) => {

    const [refreshPage, setRefreshPage] = useState(0);

    const tableCls = useTableStyle();

    const agencyReports =
        inputData?.TSctRaeoAppRegAgencyFeedback
            ?.TSctRaeoAppRegAgencyReports || [];

    const classes = useStyles();
    const { user } = useAuth();

    const currentAgencyId = user.coreAccn?.accnId || "";

    const currentAgencyReportIndex = agencyReports.findIndex(
        (report) => report.regAgency === currentAgencyId
    );

    const currentAgencyReport =
        currentAgencyReportIndex >= 0
            ? agencyReports[currentAgencyReportIndex]
            : null;

    const hasSubmittedAgencyReport =
        currentAgencyReport?.rptStatus === "S";

    // const handleInputChangeDeepWrap = (e) => {
    //     const name = e.target.name;
    //     const value = e.target.value;
    //     handleInputChangeDeep(name, value);
    //     setRefreshPage(refreshPage + 1);
    // }

    // const handleAgencyReportChange = (e) => {
    //     const value = e.target.value;

    //     let updatedReports;

    //     if (agencyReports.length > 0) {
    //         updatedReports = agencyReports.map((report, index) =>
    //             index === 0
    //                 ? {
    //                     ...report,
    //                     regAgencyRpt: value,
    //                 }
    //                 : report
    //         );
    //     } else {
    //         updatedReports = [
    //             {
    //                 regAgencyRptId: null,
    //                 regAgency: user.coreAccn?.accnId || "",
    //                 regAgencyRpt: value,
    //                 rptStatus: "A",
    //                 regAgencyRptDtCreate: null,
    //                 regAgencyRptUidCreate: user.id || null,
    //                 regAgencyRptDtLupd: null,
    //                 regAgencyRptUidLupd: null,
    //             },
    //         ];
    //     }

    //     handleInputChangeDeep(
    //         "TSctRaeoAppRegAgencyFeedback.TSctRaeoAppRegAgencyReports",
    //         updatedReports
    //     );

    //     /*
    //     * Temporary backward compatibility:
    //     * The backend currently appears to validate regRptSummary on the parent.
    //     * Keep it synchronized until that backend validation is moved to
    //     * regAgencyRpt in the child DTO.
    //     */
    //     handleInputChangeDeep(
    //         "TSctRaeoAppRegAgencyFeedback.regRptSummary",
    //         value
    //     );

    //     setRefreshPage((current) => current + 1);
    // };

    const handleAgencyReportChange = (e) => {
        const value = e.target.value;

        let updatedReports;

        if (currentAgencyReportIndex >= 0) {
            updatedReports = agencyReports.map((report, index) =>
                index === currentAgencyReportIndex
                    ? {
                        ...report,
                        regAgencyRpt: value,
                    }
                    : report
            );
        } else {
            updatedReports = [
                ...agencyReports,
                {
                    regAgencyRptId: null,
                    regAgency: currentAgencyId,
                    regAgencyRpt: value,
                    rptStatus: "D",
                    regAgencyRptDtCreate: null,
                    regAgencyRptUidCreate: null,
                    regAgencyRptDtLupd: null,
                    regAgencyRptUidLupd: null,
                    regAgencyRptDtSubmit: null,
                    regAgencyRptUidSubmit: null,
                },
            ];
        }

        handleInputChangeDeep(
            "TSctRaeoAppRegAgencyFeedback.TSctRaeoAppRegAgencyReports",
            updatedReports
        );

        setRefreshPage((current) => current + 1);
    };
    // if (!isDisabled && !(inputData?.TSctRaeoAppRegAgencyFeedback?.regAgency)) {
    //     // default agent name.
    //     //inputData.aeoAgencyName = user.coreAccn?.accnName;
    //     //handleInputChangeDeep("TSctRaeoAppRegAgencyFeedback.TCoreAccn.accnId", user.coreAccn?.accnId); 
    //     //handleInputChangeDeep("TSctRaeoAppRegAgencyFeedback.TCoreAccn.accnName", user.coreAccn?.accnName); 
    //     //handleInputChangeDeep("TSctRaeoAppRegAgencyFeedback.regAgency", user.coreAccn?.accnName); 
    // }

    const defaultUserName = (!isDisabled) ? user.name : "";

    const [openPopUp, setOpenPopUp] = useState(false);
    const [selectedRow, setSelectedRow] = useState("");

    const handlePopUpReplyWindow = (id) => {
        setSelectedRow(agencyReports[id]);
        setOpenPopUp(true);
    }
    return (
        
        showAgencyReportList ? (
            <React.Fragment>
                <C1HeaderTitle>Regulatory Agency Report List</C1HeaderTitle>
                <Box className="m-3 pt-3">
                <TableContainer component={Paper}>
                    <Table className={tableCls.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center">No.</StyledTableCell>
                                <StyledTableCell align="center">Regulatory Agency</StyledTableCell>
                                <StyledTableCell align="center">Report</StyledTableCell>
                                <StyledTableCell align="center">User</StyledTableCell>
                                <StyledTableCell align="center">Date</StyledTableCell>
                                <StyledTableCell align="center">Action</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {agencyReports.map((report, index) => (
                                <TableRow key={index}>
                                    <StyledTableCell align="center">{index + 1}</StyledTableCell>
                                    <StyledTableCell align="center">{report.regAgency}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        {/* {report.regAgencyRpt.length > 10
                                            ? report.regAgencyRpt.substring(0, 10) + '...'
                                                                               : report.regAgencyRpt} */}
{(report.regAgencyRpt || "").length > 10
    ? `${report.regAgencyRpt.substring(0, 10)}...`
    : report.regAgencyRpt || ""}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{report.regAgencyRptUidCreate}</StyledTableCell>
                                    <StyledTableCell align="center">{moment(report.regAgencyRptDtCreate).format('DD/MM/YYYY hh:mm:ss')}</StyledTableCell>
                                    <StyledTableCell align="center"><IconButton aria-label="Preview" type="button"
                                            color="primary" onClick={() => handlePopUpReplyWindow(index)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <C1PopUp
                title="Report"
                openPopUp={openPopUp}
                setOpenPopUp={setOpenPopUp}>
                <Grid container spacing={1} alignItems="center" >
                    <Grid item xs={12}>
                        <C1InputField
                            label="Report"
                            name="userFeedback"
                            multiline
                            rows={10}
                            value={selectedRow.regAgencyRpt || ''}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={9}>
                    </Grid>
                    <Grid item xs={3}>
                        {(false) && <Button variant="contained"
                            color="secondary"
                            size="large"
                            fullWidth
                            onClick={(e) => setOpenPopUp(false)}>Close</Button>}
                    </Grid>
                </Grid>
            </C1PopUp>
            </React.Fragment>
        ) : (
            <React.Fragment>
                <C1HeaderTitle>Header Information</C1HeaderTitle>
                <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                    <Grid item lg={6} md={6} xs={12}>
                        {/* <C1DateField
                            label="Regulated Date"
                            name="aeoReviewedDate"
                            value={inputData?.TSctRaeoAppRegAgencyFeedback?.regDtLupd || ""}
                            required
                            disabled
                        /> */}
                        <C1DateField
                            label={
                                hasSubmittedAgencyReport
                                    ? "Submitted Date"
                                    : "Last Saved Date"
                            }
                            name="regAgencyReportDate"
                            value={
                                hasSubmittedAgencyReport
                                    ? currentAgencyReport?.regAgencyRptDtSubmit || ""
                                    : currentAgencyReport?.regAgencyRptDtLupd ||
                                    currentAgencyReport?.regAgencyRptDtCreate ||
                                    ""
                            }
                            disabled
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12}>
                        {/* <C1InputField
                            label="Regulated By"
                            name="usrName"
                            value={inputData?.TSctRaeoAppRegAgencyFeedback?.TCoreUsr?.usrName || defaultUserName}
                            required
                            disabled
                        /> */}
                    <C1InputField
                        label={
                            hasSubmittedAgencyReport
                                ? "Submitted By"
                                : "Last Saved By"
                        }
                        name="regAgencyReportUser"
                        value={
                            hasSubmittedAgencyReport
                                ? currentAgencyReport?.regAgencyRptUidSubmit ||
                                currentAgencyReport?.regAgencyRptUidLupd ||
                                currentAgencyReport?.regAgencyRptUidCreate ||
                                ""
                                : currentAgencyReport?.regAgencyRptUidLupd ||
                                currentAgencyReport?.regAgencyRptUidCreate ||
                                defaultUserName
                        }
                        disabled
                    />
                    </Grid>
                </Grid>
                <C1HeaderTitle>Details</C1HeaderTitle>
                <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        {/* <C1InputField
                            label="Agency Name"
                            name="TSctRaeoAppRegAgencyFeedback.regAgency"
                            required
                            value={user.coreAccn?.accnName || ""}
                            disabled
                        /> */}
<C1InputField
    label="Agency Name"
    name="regAgency"
    value={user.coreAccn?.accnName || currentAgencyId}
    disabled
/>
                        {/* <C1InputField
                            multiline
                            label="Report Summary"
                            name="TSctRaeoAppRegAgencyFeedback.regRptSummary"
                            rows={5}
                            required
                            disabled={isDisabled || hasExistingAgencyReport}
                            inputProps={{ 'maxLength': 1024 }}
                            value={inputData?.TSctRaeoAppRegAgencyFeedback?.regRptSummary || ""}
                            onChange={handleInputChangeDeepWrap}
                            error={errors['TSctRaeoAppRegAgencyFeedback.regRptSummary'] !== undefined}
                            helperText={errors['TSctRaeoAppRegAgencyFeedback.regRptSummary'] || ''}
                        /> */}
                        {/* <C1InputField
                            multiline
                            label="Report Summary"
                            name="regAgencyRpt"
                            rows={5}
                            required
                            disabled={isDisabled}
                            inputProps={{ maxLength: 1024 }}
                            value={firstAgencyReport?.regAgencyRpt || ""}
                            onChange={handleAgencyReportChange}
                            error={
                                errors[
                                    "TSctRaeoAppRegAgencyFeedback.TSctRaeoAppRegAgencyReports[0].regAgencyRpt"
                                ] !== undefined ||
                                errors[
                                    "TSctRaeoAppRegAgencyFeedback.regRptSummary"
                                ] !== undefined
                            }
                            helperText={
                                errors[
                                    "TSctRaeoAppRegAgencyFeedback.TSctRaeoAppRegAgencyReports[0].regAgencyRpt"
                                ] ||
                                errors[
                                    "TSctRaeoAppRegAgencyFeedback.regRptSummary"
                                ] ||
                                ""
                            }
                        /> */}
<C1InputField
    multiline
    label="Report Summary"
    name="regAgencyRpt"
    rows={5}
    required
    disabled={
        isDisabled ||
        hasSubmittedAgencyReport
    }
    inputProps={{ maxLength: 1024 }}
    value={
        currentAgencyReport?.regAgencyRpt || ""
    }
    onChange={handleAgencyReportChange}
    error={
        errors[
            "TSctRaeoAppRegAgencyFeedback." +
            "TSctRaeoAppRegAgencyReports.regAgencyRpt"
        ] !== undefined
    }
    helperText={
        errors[
            "TSctRaeoAppRegAgencyFeedback." +
            "TSctRaeoAppRegAgencyReports.regAgencyRpt"
        ] || ""
    }
/>
                    </Grid>
                </Grid>
                <Box width={1}>&nbsp;</Box>
            </React.Fragment>
        )
    );
    
};

export default RaeoAppRegulatoryAgency;